<template>
      <div class="modal-card">
        <header class="modal-card-head" style="background: #05a859 ">
            <p class="modal-card-title" style="color:white">Murimi247 | Admin </p>
        </header>

        <section class="modal-card-body">
          <div class="columns">
            <!-- Login Form --->
            <div  class="column is-half">

            <div v-if="show=='login' && !showChangePassword">
              <h1>Login</h1>
              <b-field label="Email">
                  <b-input
                      type="email"
                      v-model="creds.username"
                      placeholder="Your email (e.g. jdoe@email.com)"
                      >
                  </b-input>
              </b-field>

              <b-field label="Password">
                  <b-input
                      type="password"
                      v-model="creds.password"

                      placeholder="Your password"
                      >
                  </b-input>
              </b-field>
              <button class="button " type="button" @click="login" size="is-medium" >Login</button>
              <br/>
              <br/>
              <a class="mx-4 clear" @click="show = 'reset-password'">Forgot Password?</a>
            </div>
            <!-- End of Login Form --->


            <!-- Reset Password Form --->

            <div v-if="show=='reset-password'">
              <h1>Reset Password</h1>
              <h4 class="text-center mb-4">An email will be sent with a reset code to enter in the next step.</h4>
              <br/>
              <br/>
              <label for="reset-password-email">Email</label>
                  <b-input
                      type="email"
                      id="reset-password-email"
                      v-model="resetPasswordCreds.email"
                      placeholder="Your email (e.g. jdoe@email.com)"
                      >
                  </b-input>
              <br/>
              <br/>

              <button class="button" type="button" size="is-medium" @click="resetPassword">Reset Password</button>
              <br/>
              <br/>
                <a class="mx-4 clear" @click="show = 'login'; clearQueryString()">Login</a>
            </div>
            <!-- End of Reset Password Form --->

            <!-- Change Password Form --->

            <div v-if="show == 'change-password' || showChangePassword">
                <h1>Change Password</h1>
                <h4>Please enter the code sent to your email and your new password.</h4>
                <b-field label="6 Digit Code">
                    <b-input
                        type="text"
                        v-model="changePasswordCreds.code"
                        placeholder="Code (e.g. 123456)"
                        >
                    </b-input>
                </b-field>

                <b-field label="New Password">
                    <b-input
                        type="password"
                        v-model="changePasswordCreds.password"

                        placeholder="Your new password"
                        >
                    </b-input>
                </b-field>
                <button class="button" type="button" size="is-medium" @click="changePassword()">Change Password</button>
                <br/>
                <br/>
                <a class="mx-4 clear" @click="show = 'login'; clearQueryString()">Login</a>
            </div>
            </div>
            <!-- End of Reset Password Form --->
            <div  class="column is-half">
              <img class="company_logo" src="../../assets/icons/logo.png" />
            </div>
          </div>
        </section>
      </div>
</template>
<script>
function getParameterByName(name) {
    var match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

import { lsSet } from '@/helpers';
export default {
  data() {
    return {
      rememberMe: false,
      creds: {
        username: "",
        password: "",
      },
      resetPasswordCreds: {
        email: ""
      },
      changePasswordCreds: {
        code: "",
        password: ""
      },
      uuid: "",
      show: "login"
    };
  },
  computed: {
    showChangePassword() {
      return window.location.search.indexOf("change-password") > -1;
    },
  },
  created() {
    console.log(window.location.search.indexOf("change-password"))
    console.log(window.location.search)
  },
  methods: {
    clearQueryString() {
      window.location.search = '';
    },
    clearFields() {
      this.creds.username = "";
      this.creds.password = "";

      this.resetPasswordCreds.email = "";

      this.changePasswordCreds.code = "";
      this.changePasswordCreds.password = "";
    },
    login: function() {
      if (this.creds.username != "" && this.creds.password != "") {
        const loading = this.$loading.open();

        this.$store.dispatch('login', this.creds).then(token=> {
            loading.close();
            if (token) {
                lsSet('token', token)
                this.$store.commit('loggedIn', true);
                window.location.href = '';
            } else {
                this.$toasted.global.error("Invalid username and password. Please try again.")
            }
        }).catch(e=>{
            loading.close();
            console.log('Exception when logging in',e);
            this.$toasted.global.error('Failed to login. Please try again.');
        })
      } else {
        this.$toasted.global.error("Make sure nothing is blank.");
      }
    },
    resetPassword: function() {
      if (this.resetPasswordCreds.email != "") {
        const loading = this.$loading.open();

        this.$store.dispatch('resetPassword', this.resetPasswordCreds.email).then(()=> {
          loading.close();
          this.$toasted.global.success("Email Sent.");
          this.show = 'change-password'
        }).catch(e=>{
          loading.close();
          console.log('Exception when resetting password',e);
          this.$toasted.global.error('Failed to send the email. Please try again.');
        })
      } else {
        this.$toasted.global.error("Make sure nothing is blank.");
      }
    },
    changePassword: function() {
      if (this.changePasswordCreds.code != "" && this.changePasswordCreds.password!="") {
        const loading = this.$loading.open();

        this.$store.dispatch('changePassword', this.changePasswordCreds).then(()=> {
          loading.close();
          this.$toasted.global.success("Password Successfully Changed.");
          this.show = 'login';
//          this.clearFields();
        }).catch(e=>{
          loading.close();
          console.log('Exception when changing password',e);
          this.$toasted.global.error('Failed to change your password. Please try again.');
        })
      } else {
        this.$toasted.global.error("Make sure nothing is blank.");
      }
    }
  }
};
</script>

<style scoped>
.modal-card {
  width: auto;

}
.button{
   background-color:  #05a859;
   color:white;
   font-weight: 700;
}
.modal-card-title{
  font-weight: bold;
  font-family: 'Roboto';
}
h1 {
  font-size: 150%;
  font-weight: 700;
  text-align: center;
}
.company_logo{
    display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;

}
</style>



// WEBPACK FOOTER //
// src/components/Accounts/LoginModal.vue